import React, { useMemo } from "react"
import classNames from "classnames"
import styles from "./index.module.scss"
import { VirtualRewardProps } from "@hg/activity-utils"
import RewardWrapper from "@/components/RewardWrapper"
import { Client } from "@/utils/gameAssets"
import { Module } from "@ak/game-assets"
import { i18n, I18nTextPath } from "@/i18n"

const VirtualReward = ({
    reward,
    onClose,
    rewardSrc,
    showAmount,
}: VirtualRewardProps & { reward: VirtualRewardProps["reward"] & { amount?: number }; rewardSrc?: string; showAmount?: boolean }) => {
    const src = useMemo(() => {
        if (rewardSrc) {
            return rewardSrc
        }
        const img = Client.get(Module.ITEM, reward.key)
        return img
    }, [reward.key, rewardSrc])
    const text = showAmount
        ? `${i18n.get(reward.title as I18nTextPath)}x${reward.amount}`
        : i18n.get(reward.title as I18nTextPath)
    
    // 根据文本长度确定字号类名
    const textSizeClass = useMemo(() => {
        const textLength = text.length
        if (textLength > 12) {
            return styles.size20
        }
        if (textLength > 10) {
            return styles.size25
        }
        if (textLength >= 8) {
            return styles.size30
        }
        if (textLength > 6) {
            return styles.size38
        }
        return undefined // 使用默认字号 48px
    }, [text])
    
    return (
        <RewardWrapper onClose={onClose} showTitle showRuleButton>
            <div className={styles.virtualReward}>
                <div className={styles.giftImg}>
                    <img src={src} alt="" />
                </div>
                <div className={styles.giftName}>
                    <div className={classNames(styles.text, textSizeClass)}>{text}</div>
                </div>
            </div>
        </RewardWrapper>
    )
}

export default VirtualReward
